export default "__VITE_ASSET__BYfgqCKX__"